import http from "../services/httpCommon1";

class ServiceEnquiryService {
  serviceEnquiryForm(id) {
    let payload = {
      enquiryId: id
    };
    return http.post(`/statusLog/getEnquiryStatusLogList`, payload);
  }
}

export default new ServiceEnquiryService();